import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchAnnouncements } from '../../stores/announcements/actions';

const Fetcher = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchAnnouncements());
  }, [dispatch]);

  return <></>;
};

export default Fetcher;
